module.exports = __webpack_public_path__ + "media/images/icon__community-f20ab39f9d2849758a56bba49f34566a.png";